export default{props:["name"],data:function data(){return{}},created:function created(){this.$store.commit("addView",this.name)},computed:{isVisible:function isVisible(){return this.$store.state.view===this.name}}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/View.vue
// module id = 269
// module chunks = 0